<form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPasswordSubmit()">
  <div class="input-container">
    <label>New Password</label>
    <mat-form-field appearance="outline">
      <input matInput formControlName="password" type="password" />
      <mat-error class="error" *ngIf="errorHandling('password', 'required')">
        Password is <strong>Required</strong>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="input-container">
    <label>Reenter Password</label>
    <mat-form-field appearance="outline">
      <input matInput formControlName="confirmPassword" type="password" />
      <mat-error
        class="error"
        *ngIf="errorHandling('confirmPassword', 'required')"
      >
        Password confirm is <strong>Required</strong>
      </mat-error>
      <mat-error
        class="error"
        *ngIf="errorHandling('confirmPassword', 'notSame')"
      >
        Passwords must match
      </mat-error>
    </mat-form-field>
  </div>
  <button mat-flat-button color="accent">
    Reset Password
  </button>
</form>
